/**
 * App download URLs for the "order on app only" flow (Zomato-style).
 * Used when web ordering is disabled and users are directed to the mobile app.
 */
export const APP_DOWNLOAD_URLS = {
  playStore: 'https://play.google.com/store/apps/details?id=com.fynito.user&pcampaignid=web_share',
  appStore: 'https://apps.apple.com/in/app/fynito/id6739328008',
};

/** Default URL when opening "Download the App" (e.g. from a single button). Opens Play Store; user can switch on device. */
export const DEFAULT_APP_DOWNLOAD_URL = APP_DOWNLOAD_URLS.playStore;

export const APP_NAME = 'Fynito';
